import {NavigationPageType} from '~shared/models';

export type DropPosition = 'top' | 'inner' | 'bottom';

export type NavigationItemLoadMoreType = 'prev' | 'next';

export interface NavigationEntityState {
    expandedState: NavigationItemExpandedState;
    children: string[];
    loading: boolean;
    loadingNext: boolean;
    loadingPrev: boolean;
    type: NavigationPageType;
    hasChildren: boolean;
    parent?: string;
    slug: string;
    prevCursor: string | null;
    nextCursor: string | null;
    isFixed: boolean;
    virtualSlug?: string;
}

export enum NavigationItemExpandedState {
    Expanded = 'expanded',
    Closed = 'closed',
    NeedsExpand = 'needs-expand',
}
